import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FeaturePhotoPoint } from 'meta/photo/photoPoint'

import { projectsApi } from 'client/store/projects/projectsApi'
import { ProjectsSelector } from 'client/store/projects/selector'

export const useGetPhotoPoints = projectsApi.endpoints.getPhotoPoints.useQuery

export const useGetPhotoPointsByIds = (
  projectName: string,
  ids: Array<number>
): Array<FeaturePhotoPoint> | undefined => {
  const selector = useMemo(() => ProjectsSelector.getPhotoPointsByIds(projectName, ids), [projectName, ids])

  return useSelector(selector)
}
